export const getActiveView = (state) => state.nav.activeView;

export const getSelectedFeature = (state) => state.nav.selectedFeature;

export const getShowTermsAndConditions = (state) => state.nav.showTermsAndConditions;

export const getGoBack = (state) => state.nav.goBack;
